'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SubscribeButton = undefined;

var _themeProvider = require('@spp/theme-provider');

var _SubscribeButton = require('./SubscribeButton');

var _SubscribeButton2 = _interopRequireDefault(_SubscribeButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable import/no-named-as-default */
exports.SubscribeButton = _SubscribeButton2.default;
exports.default = (0, _themeProvider.themer)('@spp/cn-subscribe-button')(_SubscribeButton2.default);
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-core-navigation/lib/cjs/components/SubscribeButton/index.js
 ** module id = 619
 ** module chunks = 1
 **/